import { ThemeAPI } from '../src/themeAPI';

const getSavedThemeLocal = ThemeAPI.getSavedThemeLocal;

export { getSavedThemeLocal };
